import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui/box';

export const RewardRow = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.rewardRow, style]} />
);

const styles = StyleSheet.create({
  rewardRow: {
    flexDirection: 'row',
  },
});
